import { TEditTasklist } from '../../../../types';

const INITIAL_TASKLIST: TEditTasklist = {
  locations: [],
  visibility: [] as TEditTasklist['visibility'],
  name: '',
  assign: {} as TEditTasklist['assign'],
  description: '',
  tasks: [],
  notifyAssignee: false,
  isAssigned: false,
  isDated: false,
  date: null,
};

export {
  INITIAL_TASKLIST,
};
